export default {
  // Hero
  hero_title: "VERTICAL CONSTRUCTION EQUIPMENT CATALOG",
  hero_view_products: "View Products",
  hero_request_quote: "Request Quote",

  // Products Section
  products_title: "High Performance Equipment",
  product1_name: "Rack and Pinion Construction Hoist",
  product2_name: "Climbing Crane with Lifting System",

  // Specifications
  spec_work_height: "Working Height",
  spec_load_capacity: "Load Capacity",
  spec_speed: "Speed",
  spec_configuration: "Configuration",
  spec_total_area: "Total Internal Area",
  spec_floor_area: "Floor Area",
  spec_volume: "Approximate Volume",
  spec_tower_height: "Tower Height",
  spec_service_height: "Service Height",
  spec_max_capacity: "Maximum Capacity",
  spec_steel_cables: "Steel Cables",

  // Product Details
  product1_safety_title: "Safety Features",
  product1_safety_desc: "System without gate",
  product2_accessories_title: "Included Accessories",
  product2_accessories_desc: "Fork for loads up to 2,000 kg + Concrete bucket",

  // Video Section
  video_title: "See the Equipment in Operation",

  // Conditions
  conditions_delivery_title: 'Delivery and Payment Terms',
  conditions_delivery_subtitle: 'Information about deadlines and logistics',
  conditions_shipping_title: 'Shipping Forecast',
  conditions_shipping_desc: '30 days after order confirmation',
  conditions_delivery_card_title: 'Delivery',
  conditions_delivery_desc: '60 days after shipment (destination port)',
  conditions_packaging_title: 'Packaging',
  conditions_packaging_desc: 'Wooden Case',
  conditions_warranty_title: 'Warranty',
  conditions_warranty_period: '1 year provided by manufacturer',
  conditions_manufacturer_title: 'Manufacturer',

  // Contact
  contact_title: "Get in Touch",
  contact_schedule_title: "Schedule a Meeting",
  contact_schedule_desc: "Talk to our team via Microsoft Teams",
  contact_email_title: "Contact Us",
  contact_email_desc: "Send an email to our sales team",

  // Footer
  footer_description: "Imported equipment for vertical construction",
  footer_products: "Products",
  footer_product1: "Construction Hoist",
  footer_product2: "Climbing Crane",
  footer_info: "Information",
  footer_about: "About Us",
  footer_warranty: "Warranty",
  footer_delivery: "Delivery",
  footer_contact: "Contact",
  footer_address: "R. Voluntários da Pátria, nº 2468 / 2490, 6th floor",
  footer_building: "Brasília Corporate Building",
  footer_hours: "Monday to Friday, 08:30 to 18:00 (GMT -03:00)",
  footer_rights: "© 2026 Moviis. All rights reserved.",

  // Language Switcher
  language_select: "Select language",

  share: {
    whatsappMessage: 'Hello! Here is the Moviis vertical construction equipment catalog:',
    emailSubject: 'Moviis Catalog — Vertical Construction Equipment',
    emailBody: 'Hello! Here is the Moviis vertical construction equipment catalog:',
    whatsappTooltip: 'Share on WhatsApp',
    emailTooltip: 'Share by Email',
  },

  // Financial Summary
  financial_title: 'Financial Summary',
  financial_subtitle: 'Values and payment terms',
  financial_total_label: 'Order Total',
  financial_total_value: 'Upon request',
  financial_installment1_label: 'Installment 1',
  financial_installment1_desc: '30% to start production',
  financial_installment1_value: 'Upon request',
  financial_installment2_label: 'Installment 2',
  financial_installment2_desc: 'Product payment for shipment release',
  financial_installment2_value: 'Upon request',
  financial_installment3_label: 'Installment 3 (Balance)',
  financial_installment3_desc: 'Arrival at destination (port or airport)',
  financial_installment3_value: 'Upon request',
  financial_invoice_date: 'Date: February 4, 2026',
  financial_considerations_title: 'Proposal Considerations',
  financial_considerations_subtitle: 'Important terms and conditions',
  financial_validity_label: 'Proposal validity:',
  financial_validity: '15 days',
  financial_shipping_label: 'Shipping deadline:',
  financial_shipping: 'Equipment must be shipped within 3 months. After this period, the contract will be considered invalid.',
  financial_observation_label: 'Note:',
  financial_observation: 'As this is a direct import of 10 pieces of equipment, any replacement or inclusion of new items will result in recalculation of values.',
  financial_assembly_label: 'Assembly and technical maintenance:',
  financial_assembly: 'Not included (buyer\'s responsibility).',
  financial_btn_print: 'Print',
  financial_btn_pdf: 'Download PDF',
  financial_btn_whatsapp: 'Send via WhatsApp',
  financial_btn_email: 'Send via Email',
};